import { tailwindSheet, baseStyles } from '../../_shared/styles.js';

const sheet = new CSSStyleSheet();
sheet.replaceSync(`
    :host {
        display: block;
    }
`);

export default [tailwindSheet, baseStyles, sheet];
